import {Styles} from "../Styles";
import {FaPlus} from "react-icons/fa";
import React, {useState} from "react";
import useSquad from "../../../Provider/useSquad";
import {Elements} from "../../../Styles/Elements";

export const CreateSquad = () => {

	const { Actions } = useSquad();

	const [newTeamName, setNewTeamName] = useState("");
	const [newTeamCallSign, setNewTeamCallSign] = useState("");

	const handles = {
		createSquad: () => {
			const name = newTeamName.trim();
			const callSign = newTeamCallSign.trim();

			if (!name || !callSign) {
				return;
			}

			Actions.squads.create(name, callSign);
			setNewTeamName("");
			setNewTeamCallSign("");
		},
	}

	return <Elements.Frames.Section>
		<Elements.Frames.SectionTitle>Neues Squad erstellen</Elements.Frames.SectionTitle>

		<Styles.FormRow>
			<Styles.Input
				placeholder="Regiment"
				value={newTeamName}
				onChange={event => setNewTeamName(event.target.value)}
			/>
			<Styles.Input
				placeholder="Rufzeichen"
				value={newTeamCallSign}
				onChange={event => setNewTeamCallSign(event.target.value)}
			/>
		</Styles.FormRow>

		<Elements.Buttons onClick={ handles.createSquad } icon={<FaPlus />} variant={"primary"}>
			Regiment erstellen
		</Elements.Buttons>
	</Elements.Frames.Section>
}